export default __webpack_public_path__ + "static/media/mooncake-progress-2-4.c353770a.svg";